import config from '../../../data/filler_metal_needed.json';

export async function loadFillerConfig() {
  return config;
}
